import globals from './globals.json'

const colors = globals.colors

export default colors
